// R-feat-2026-10-17 U4 易用性:网络状态 Banner
//
// 行为:
//   - 断网时顶部 Alert 警示「网络已断开」+ 离线队列项计数(若有)
//   - 离线队列有待处理项时,提供「立即重试」「全部取消」按钮
//   - 网络恢复 3s 后显示「网络已恢复」success banner,然后自动隐藏
import { useEffect, useState } from 'react'
import { Alert, Space, Button, Tag } from 'antd'
import { DisconnectOutlined, WifiOutlined, ReloadOutlined, CloseOutlined } from '@ant-design/icons'
import { useNetworkStatus } from '../../hooks/useNetworkStatus'
import { useOfflineQueue, flushOfflineQueue } from '../../hooks/useOfflineQueue'
import { useMessage } from '../../hooks/useMessage'

export default function NetworkStatusBanner() {
  const { isOnline, wasOffline, acknowledgeRecovery } = useNetworkStatus()
  const { queue, clear, retryNow } = useOfflineQueue()
  const message = useMessage()
  const [showRecovery, setShowRecovery] = useState(false)

  // 网络恢复:弹 toast + 显示「已恢复」banner 3s + 自动 flush 离线队列
  useEffect(() => {
    if (!wasOffline || !isOnline) return
    setShowRecovery(true)
    message.success('网络已恢复', 2)
    const queuedCount = queue.length
    if (queuedCount > 0) {
      // 自动 retry,指数退避
      flushOfflineQueue({ isOnline: true })
      message.info(`正在自动重试 ${queuedCount} 项离线操作`, 4)
    }
    const t = setTimeout(() => {
      setShowRecovery(false)
      acknowledgeRecovery()
    }, 3000)
    return () => clearTimeout(t)
    // 故意只依赖 wasOffline/isOnline 转跳边沿,避免每次 message 引用变化都触发
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wasOffline, isOnline])

  if (!isOnline) {
    return (
      <Alert
        type="warning"
        showIcon
        icon={<DisconnectOutlined />}
        message="网络已断开,部分功能可能不可用"
        description={
          queue.length > 0 ? (
            <Space size={8} wrap>
              <Tag color="orange">{queue.length} 项操作待重试</Tag>
              <Button
                size="small"
                type="primary"
                ghost
                icon={<ReloadOutlined />}
                onClick={() => retryNow()}
              >
                立即重试
              </Button>
              <Button size="small" danger ghost icon={<CloseOutlined />} onClick={() => clear()}>
                全部取消
              </Button>
            </Space>
          ) : null
        }
        banner
        style={{ position: 'sticky', top: 0, zIndex: 1100 }}
      />
    )
  }

  if (showRecovery) {
    return (
      <Alert
        type="success"
        showIcon
        icon={<WifiOutlined />}
        message="网络已恢复"
        banner
        style={{ position: 'sticky', top: 0, zIndex: 1100 }}
      />
    )
  }

  return null
}
